export const AUTH_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';
